import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ApplicationContextProvider } from "./context/application-context";
import eruda from "eruda";
const root = ReactDOM.createRoot(document.getElementById("root"));
if (process.env.REACT_APP_ENV === "staging") {
    // Dynamically import eruda only in development
    const erudaScript = document.createElement("script");
    erudaScript.src = "https://cdn.jsdelivr.net/npm/eruda";
    erudaScript.onload = () => {
        eruda.init(); // Initialize eruda when the script is loaded
    };
    document.body.appendChild(erudaScript);
}
const headerStyle = {
    textAlign: "center",
    color: "#fff",
    height: 64,
    paddingInline: 48,
    lineHeight: "64px",
    backgroundColor: "#4096ff",
};
root.render(_jsx(React.StrictMode, { children: _jsx(ApplicationContextProvider, { children: _jsx(App, {}) }) }));
// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
